import { httpClient } from './http'

export async function startDaemon({ id, apikey }) {
  const patch = { data: { attributes: { status: 'ready' } } }
  try {
    const res = await httpClient.patch(`/v1/daemons/${id}`, patch, {
      params: { apikey }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}

export async function stopDaemon({ id, apikey }) {
  const patch = { data: { attributes: { status: 'stopped' } } }
  try {
    const res = await httpClient.patch(`/v1/daemons/${id}`, patch, {
      params: { apikey }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}
